<template>
  <span class="sort-select"
    ><base-select
      name="sort-select"
      :select-options="sortOptions"
      @change="sortOptionChanged"
    >
      <template #label-status> &#8203; </template>
      <template #label> <translate>Sort by</translate>: </template>
      <template #helpText>
        <translate
          v-visible="searchStore.context?.results?.sortOption === 'distance'"
        >
          All distances are calculated 'as the crow flies'.
        </translate>
      </template>
    </base-select></span
  >
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { sortOptionsMap } from '~/utility/search'

const searchStore = useSearchStoreSetup(usePinia())

const sortOptions = computed(() => {
  if (searchStore.context?.results?.sortOptions) {
    return searchStore.context.results.sortOptions.map((option) => {
      return {
        name: useI18n().t(sortOptionsMap[option]),
        value: option,
        selected: option === searchStore.context?.results.sortOption,
      }
    })
  }
  return []
})

function sortOptionChanged(sort) {
  const router = useRouter()
  const currentQuery = { ...router.currentRoute.value.query }
  const currentPath = router.currentRoute.value.path
  delete currentQuery.page

  if (
    sort.selectedValue &&
    sort.selectedValue !== searchStore.context?.results.sortOption
  ) {
    void router.push({
      path: currentPath.endsWith('/') ? currentPath : `${currentPath}/`,
      query: {
        ...currentQuery,
        sort: sort.selectedValue,
      },
    })
  }
}
</script>
<style scoped>
.sort-select :deep(label) {
  color: var(--colour-wcag-blue);
  font-weight: normal;
  display: block;
}

.sort-select :deep(.help-text) {
  font-size: var(--small);
  margin: 0.25em 0 0 0.25em;
  color: var(--colour-text-default);
}

.sort-select {
  margin-top: auto;
}
</style>
